// jquery-ui modules bundle as browser-global UMD (no CJS branch), so the
// `./version` dependency that creates `$.ui` never loads implicitly — import
// it explicitly before any other jquery-ui module or `$.ui.*` assignments throw.
import "jquery-ui/ui/version";
import "jquery-ui/ui/scroll-parent";

(function ($) {
  const openClass = "show-menu";
  const dropdownButtonSelector = ".dropdown-button";
  const menuSelector = ".dropdown-menu";
  const ignoreSelector = "[data-close-menu=false]";
  const minDropdownDistance = 5;

  let openMenus = jQuery();

  // BEHAVIOUR

  // Listen on body instead of document to work around https://github.com/rails/jquery-ujs/issues/327
  jQuery(document).on("click", openOrClose);
  jQuery(document).on("keyup", dropdownButtonSelector, function (event) {
    if (event.which == 13) {
      openOrClose(event);
    }
  });
  jQuery(document).on("dropdown:close", ".dropdown", openOrClose);

  // HELPER FUNCTIONS

  function openOrClose(event) {
    const $el = eventTarget(event);
    const menuToOpen = $el.closest(dropdownButtonSelector).nextAll(menuSelector).not(openMenus);
    const menusToClose = openMenus.not(menuToOpen);
    const ignoreClick = $el.closest(ignoreSelector).length;

    if (!ignoreClick) {
      openMenu(menuToOpen);
      closeMenu(menusToClose);
    }
  }

  // Get the clicked element even from within custom elements
  function eventTarget(event) {
    // Handle jQuery events. Drill down to the native event so we can check if it was composed.
    while (event.originalEvent && event.originalEvent != event) {
      event = event.originalEvent;
    }

    if (event.composed) {
      return jQuery(event.composedPath()[0]);
    } else {
      return jQuery(event.target);
    }
  }

  function openMenu(menu) {
    jQuery(menu).each(openMenuInstance);
    openMenus = openMenus.add(menu);

    function openMenuInstance(i, menu) {
      const $menu = jQuery(menu);
      const callback = function () {
        if (!$menu.parents(".dropdown").hasClass("dropdown-no-auto-position")) {
          autoPosition(menu);
        }

        $menu.addClass(openClass);
        $menu.trigger("dropdown-menu:opened");
      };

      callback();
    }
  }

  function autoPosition(menu) {
    var direction = dropdownDirection(menu, jQuery(menu).scrollParent());
    jQuery(menu).parent().removeClass("up down").addClass(direction);
  }

  function closeMenu(menu) {
    jQuery(menu).each(function (index, el) {
      const $menu = jQuery(this);
      $menu.removeClass(openClass);
      $menu.trigger("dropdown-menu:closed");
    });
    openMenus = openMenus.not(menu);
  }

  function dropdownDirection(menu, $scrollParent) {
    if ($scrollParent.length) {
      const parent =
        jQuery(menu).parent().offset().top +
        jQuery(menu).parent().children(".dropdown-button").height() +
        parseInt(jQuery(menu).parent().children(".dropdown-button").css("padding-top"), 10);

      const menuSize = jQuery(menu).outerHeight();

      const dropdownPosition = $scrollParent[0].scrollHeight - $scrollParent.scrollTop();
      const totalHeight = parent + menuSize - dropdownPosition;

      if (menuSize > parent) {
        return "down";
      } else if (totalHeight > minDropdownDistance) {
        return "up";
      } else {
        return "down";
      }
    } else {
      return "down";
    }
  }
})(jQuery);
